import React from 'react';
import AdminManagement from '../components/AdminManagement';

const AdminsPage: React.FC = () => <AdminManagement />;

export default AdminsPage;
